import { call, put, select } from 'redux-saga/effects';
import UserClient from '../../api/UserClient';
import { messagesShow } from '../../redux/messages/actions';
import { subscriptionIdSelector, profileIdSelector } from '../../selectors/user';
import { setSubscriptions, setSubscriptionsUpdating } from '../../redux/user/actions';

export default function* unsubscribeFromAPlan({ payload: { callback } }) {
    try {
        yield put(setSubscriptionsUpdating(true));

        const subscriptionId = yield select(subscriptionIdSelector);
        const profileId = yield select(profileIdSelector);
        const currentSubscription = yield call(UserClient.unsubscribeFromAPlan, { subscriptionId, profileId });

        yield put(setSubscriptions([currentSubscription]));
        yield put(messagesShow('unsubscribeSuccess', 'success'));
    } catch (error) {
        yield put(messagesShow('unsubscribeError', 'error'));
        console.error('[unsubscribeFromAPlan]', error);
    } finally {
        yield put(setSubscriptionsUpdating(false));

        if (callback) {
            callback();
        }
    }
}
